import { ProjectsState } from './types';
import { RootState } from 'store/root-reducer';
import { createSelector } from '@reduxjs/toolkit';

const selectProjectsReducer = (state: RootState): ProjectsState => state.projects;

export const selectProjectsIsEmpty = createSelector([selectProjectsReducer], (projects) => projects.projectsIsEmpty);

export const selectProjectsLoading = createSelector([selectProjectsReducer], (projects) => projects.projectsLoading);

export const selectProjects = createSelector([selectProjectsReducer], (projects) => projects.projects);
